import React from 'react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { Award, Users, TrendingUp, Zap } from 'lucide-react';
import { portfolioData } from '../data/mock';

const About = () => {
  const { about } = portfolioData;

  const stats = [
    { icon: Users, label: 'Team Size Led', value: '10+ Engineers', color: 'text-blue-400' },
    { icon: TrendingUp, label: 'Test Coverage', value: '95%', color: 'text-green-400' },
    { icon: Zap, label: 'Defect Reduction', value: '99%', color: 'text-yellow-400' },
    { icon: Award, label: 'Awards Won', value: '2+', color: 'text-purple-400' }
  ];

  return (
    <section id="about" className="py-20 bg-slate-900 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-blue-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-600/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            About <span className="text-blue-400">Me</span>
          </h2>
          <div className="w-20 h-1 bg-blue-500 mx-auto"></div>
        </div>

        <div className="max-w-6xl mx-auto">
          {/* Description */}
          <div className="mb-12">
            <p className="text-lg text-gray-300 leading-relaxed mb-6">
              {about.description}
            </p>
          </div>

          {/* Stats Grid */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-12">
            {stats.map((stat, index) => (
              <Card
                key={index}
                className="bg-slate-800/50 border-slate-700 hover:border-blue-500/50 transition-all duration-300 hover:scale-105 p-6 text-center group"
              >
                <stat.icon className={`${stat.color} mx-auto mb-3 group-hover:scale-110 transition-transform duration-300`} size={32} />
                <div className="text-2xl sm:text-3xl font-bold text-white mb-1">{stat.value}</div>
                <div className="text-xs sm:text-sm text-gray-400">{stat.label}</div>
              </Card>
            ))}
          </div>

          {/* Key Highlights */}
          <div>
            <h3 className="text-2xl font-semibold text-white mb-6 flex items-center">
              <Award className="text-blue-400 mr-3" size={28} />
              Key Highlights
            </h3>
            <div className="grid sm:grid-cols-2 gap-4">
              {about.highlights.map((highlight, index) => (
                <div
                  key={index}
                  className="flex items-start gap-3 p-4 bg-slate-800/30 border border-slate-700/50 rounded-lg hover:border-blue-500/30 transition-all duration-300 group"
                >
                  <div className="flex-shrink-0 w-2 h-2 bg-blue-400 rounded-full mt-2 group-hover:scale-150 transition-transform duration-300"></div>
                  <p className="text-gray-300 text-sm sm:text-base leading-relaxed">{highlight}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Awards Section */}
          <div className="mt-12">
            <div className="flex flex-wrap gap-4 justify-center">
              {portfolioData.awards.map((award, index) => (
                <Badge
                  key={index}
                  className="bg-blue-600/20 border border-blue-500/30 text-blue-300 px-4 py-2 text-sm hover:bg-blue-600/30 transition-colors duration-300"
                >
                  <Award size={16} className="mr-2" />
                  {award}
                </Badge>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;